import { Payload } from '../../types/payload';

export const axiosNetworkErrorFilter = (msg: string, payload?: Payload) =>
  !(payload instanceof Error && payload.message === 'Network Error');
